import PDFService from "@/services/pdf/PDFService";
import { getCustomParams, getPaginationParams } from "@/utils/common/http";
import nfetch from "@/utils/events/nfetch";

class NotaFiscalEletronicaEmissaoLoteService {
    PDFService = new PDFService("");

    public list(pageIndex: number, pageSize: number, filterKey: string, customProperties: { [key: string]: any } = {}) {
        const custom = getCustomParams(customProperties);
        const pagination = getPaginationParams(filterKey, "", "", pageIndex, pageSize);

        return nfetch(`/NotaFiscalEletronicaEmissaoLote/List?${pagination}` + custom, {
            credentials: "same-origin",
        });
    }

    public emitirEmLoteByVendaIds(vendaIds: Array<number>) {
        return nfetch(`/NotaFiscalEletronicaEmissaoLote/EmissaoLoteByVendaIds`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(vendaIds),
        });
    }

    public exportPDF(filterKey: string, customProperties: { [key: string]: any } = {}) {
        const custom = getCustomParams(customProperties);
        const pagination = getPaginationParams(filterKey, "", "", 0, 0);

        const url = `/NotaFiscalEletronicaEmissaoLote/ExportPDF?${pagination}` + custom;

        this.PDFService.imprimirPDF(url);
    }

    public exportXLS(
        filterKey: string,
        customProperties: { [key: string]: any } = {},
        tipoExportacaoXLS: number,
    ): Promise<Response> {
        const custom = getCustomParams(customProperties);
        const pagination = getPaginationParams(filterKey, "", "", 0, 0);

        return nfetch(
            `/NotaFiscalEletronicaEmissaoLote/ExportXLS?tipoExportacaoXLS=${tipoExportacaoXLS}&${pagination}` + custom,
            {
                method: "post",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            },
        );
    }
}

export default new NotaFiscalEletronicaEmissaoLoteService();
